module.exports = __webpack_public_path__ + "c1a1720fef0281e731aeeecc72077698.jpg";